import { useQuery } from '@tanstack/react-query';
import { useClient } from 'hooks/useClient';

/** Signatures last a day; an hour old is still good for most of it. */
const STALE_MS = 60 * 60 * 1000;

type Signatures = Record<number, string>;

const NONE: Signatures = {};

/**
 * The report signatures an experiment's QA preview links carry, one per variant (PER-333), so the
 * preview report a link sends is marked as from a link someone signed in handed out. Empty while they
 * load or when the experiment is not in QA, cached ones included: a signature must not reach a live
 * experiment's link, and the links work the same without one.
 */
export const usePreviewSignatures = (experimentId: number | undefined, isQa: boolean): Signatures => {
  const client = useClient();
  const { data } = useQuery<{ signatures: Signatures }>({
    queryKey: ['PREVIEW_SIGNATURES', experimentId],
    queryFn: () => client.get<{ signatures: Signatures }>(`/editor-data/experiment/${experimentId}/preview-signatures`),
    enabled: !!experimentId && isQa,
    staleTime: STALE_MS,
  });
  return isQa ? (data?.signatures ?? NONE) : NONE;
};
